<div class="container">
    <div class="card">
      <div class="task-head">
        <h4>Warning!</h4>
      </div>
      <p *ngIf="data?.message === 'toi'">
        <span *ngIf="checkedCount === 1">Time of your interest (TOI) has expired, and the satellite can no longer be tasked. Please re-task.</span>
        <span *ngIf="checkedCount > 1">Time of your interest (TOI) has expired, and the satellite(s) can no longer be tasked. Please re-task.</span>
      </p>

      <p *ngIf="data?.message === 'umbra'">
        <span *ngIf="checkedCount === 1">Time of your interest (TOI) has already started, and the operator will reject this order.</span>
        <span *ngIf="checkedCount > 1">Time of your interest (TOI) has already started, and the {{this.umbra}} will reject this order.</span>
      </p>

      <p *ngIf="data?.message === 'feasibility'">
        Please choose capture opportunities from the feasibility list.
      </p>

      <p *ngIf="data?.message === 'cartFeasible'">
        This is an opportunity based task, please proceed from dashboard.
      </p>

      <p *ngIf="data?.message === 'head'">
        The opportunities identified for tasking have expired. Kindly re-task.
      </p>
    </div>
  
    <div class="btns">
      <button mat-flat-button (click)="onNoClick()">Ok, Thanks</button>
    </div>
  </div>